import { t } from "i18next";
import _ from "lodash";
import { useEffect, useState } from "react";
import { HourHeatMap } from "./HourHeatMap";
import TimelineChart from "./TimelineChart";
import { useFetch } from "../../../../../hooks/useFetch";
import { useAppStore } from "../../../../../stores/RootStore";
import { DataRow, PersonUsageRow, SummaryPersonUsageRow } from "../../../../../stores/TabsStore";
import { DateShift, Equipment, Event, EventsResponseItem, FShift, GrouppedData, Person } from "../../../../../types/types";
import Spinner from "../../../../../ui/Spinner/Spinner";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";
import { transformEvent } from "../../../../../lib/calculations";
import { DateTime, Duration } from "luxon";

export function EquipmentInteractions({person, data}:{person: Person, data: DataRow[]}) {
  let grouppedByDay = _.groupBy(_.orderBy(data, el => el.dateShift.start_day) , el => el.dateShift.start_day)

  function getParamsByCardType(type: string, day: DataRow) {
    switch (type) {
      case "manual": return (
        <>
          <div className="col-span-1 flex justify-end">{day.works.on.time}</div>
          <div className="col-span-1 flex justify-end">{day.works.worked.time}</div>
          <div className="col-span-1 flex justify-end">{day.works.stopped.time}</div>
          <div className="col-span-1 flex justify-end">{day.works.off.time}</div>
        </>
      )
      case "adjustment": return (
        <>
          <div className="col-span-1 flex justify-end">{day.maintenance.on.time}</div>
          <div className="col-span-1 flex justify-end">{day.maintenance.worked.time}</div>
          <div className="col-span-1 flex justify-end">{day.maintenance.stopped.time}</div>
          <div className="col-span-1 flex justify-end">{day.maintenance.off.time}</div>
        </>
      )
      case "repair": return (
        <>
          <div className="col-span-1 flex justify-end">{day.repair.on.time}</div>
          <div className="col-span-1 flex justify-end">{day.repair.worked.time}</div>
          <div className="col-span-1 flex justify-end">{day.repair.stopped.time}</div>
          <div className="col-span-1 flex justify-end">{day.repair.off.time}</div>
        </>
      )
      case "service": return (
        <>
          <div className="col-span-1 flex justify-end">{day.service.on.time}</div>
          <div className="col-span-1 flex justify-end">{day.service.worked.time}</div>
          <div className="col-span-1 flex justify-end">{day.service.stopped.time}</div>
          <div className="col-span-1 flex justify-end">{day.service.off.time}</div>
        </>
      )
      default: return (
        <>
          <div className="col-span-1 flex justify-end">{day.works.on.time}</div>
          <div className="col-span-1 flex justify-end">{day.works.worked.time}</div>
          <div className="col-span-1 flex justify-end">{day.works.stopped.time}</div>
          <div className="col-span-1 flex justify-end">{day.works.off.time}</div>
        </>
      )
    }
  }

  return (
    <div className="flex flex-col space-y-2 my-6">
      <div className="grid grid-cols-12 text-sm px-4">
        <div className="col-span-3 flex space-x-2"><div className="font-semibold">{t('date')}</div></div>
        <div className="col-span-3 flex">{t('interaction')}</div>
        <div className="col-span-1 flex justify-end">{t('worked')}</div>
        <div className="col-span-1 flex justify-end">{t('stopped')}</div>
        <div className="col-span-2 flex justify-end">{t('maintenance')}</div>
        <div className="col-span-1 flex justify-end">{t('repair')}</div>
        <div className="col-span-1 flex justify-end">{t('service')}</div>
      </div>
      {grouppedByDay ? Object.entries(grouppedByDay).map(([day, dayData]) => {
        let ordered = _.orderBy(dayData, el => el.dateShift.start_time)
        let duration = _.sum(ordered.map(r => r.availability.on.seconds)) + _.sum(ordered.map(r => r.unavailability.on.seconds))
        return (
          <div key={day} className="border flex flex-col rounded text-sm">
            <div className="w-full flex flex-col">
              <div className="grid grid-cols-12 px-4 py-2">
                <div className="col-span-3 font-semibold">{ordered[0].dateShift.start_day.toFormat("dd.MM.yyyy")} ({ordered[0].dateShift.start_day.weekdayLong})</div>
                <div className="col-span-3">{Duration.fromObject({seconds: duration }).toFormat("hh:mm:ss")}</div>
                <div className="col-span-1 flex justify-end space-x-2">
                  <span>{Duration.fromObject({seconds: _.sum(ordered.map(r => r.availability.worked.seconds))}).toFormat("hh:mm:ss")}</span>
                  <span className="font-medium">{((_.sum(ordered.map(r => r.availability.worked.seconds)) / duration) * 100).toFixed(1)}%</span>
                </div>
                <div className="col-span-1 flex justify-end space-x-2">
                  <span>{Duration.fromObject({seconds: _.sum(ordered.map(r => r.availability.stopped.seconds))}).toFormat("hh:mm:ss")}</span>
                  <span className="font-medium">{((_.sum(ordered.map(r => r.availability.stopped.seconds)) / duration) * 100).toFixed(1)}%</span>
                </div>
                <div className="col-span-2 flex justify-end space-x-2">
                  <span>{Duration.fromObject({seconds: _.sum(ordered.map(r => r.maintenance.on.seconds))}).toFormat("hh:mm:ss")}</span>
                  <span className="font-medium">{((_.sum(ordered.map(r => r.maintenance.on.seconds)) / duration) * 100).toFixed(1)}%</span>
                </div>
                <div className="col-span-1 flex justify-end space-x-2">
                  <span>{Duration.fromObject({seconds: _.sum(ordered.map(r => r.repair.on.seconds))}).toFormat("hh:mm:ss")}</span>
                  <span className="font-medium">{((_.sum(ordered.map(r => r.repair.on.seconds)) / duration) * 100).toFixed(1)}%</span>
                </div>
                <div className="col-span-1 flex justify-end space-x-2">
                  <span>{Duration.fromObject({seconds: _.sum(ordered.map(r => r.service.on.seconds))}).toFormat("hh:mm:ss")}</span>
                  <span className="font-medium">{((_.sum(ordered.map(r => r.service.on.seconds)) / duration) * 100).toFixed(1)}%</span>
                </div>
              </div>
              {dayData.map((r, i) => <DayEquipmentInteraction key={i} data={r!}/>)}
              
            </div>
          </div>
        )
        })
        :
        <div>{t('no_data')}</div>
      }
    </div>
  )
}


function DayEquipmentInteraction({data}:{data: DataRow}) {
  const shift = useAppStore().shifts.find(s => s.id === data.dateShift.id) as unknown as FShift
  const [open, setOpen] = useState(false)

  return (
    <div className="px-4 py-2 bg-muted border-border border-b last:border-0">
      <div className="flex flex-col space-y-2" >
        <div className="grid grid-cols-12">
          <div className="col-span-3 flex cursor-pointer items-center space-x-2 hover:text-primary truncate" onClick={() => setOpen(!open)}>
            {open ? <TbChevronUp className="w-6" /> : <TbChevronDown className="w-6"/>}
            <div className="font-semibold">{data.equipment.attributes.name}</div>
          </div>
          <div className="col-span-3 font-semibold">{data.dateShift.label} ({t(data.person?.attributes.access_tokens.find(c => c.id === data.interactionIds[0])?.access_token_type!)})</div>
          <div className="col-span-1 flex justify-end">{data.works.worked.time}</div>
          <div className="col-span-1 flex justify-end">{data.works.stopped.time}</div>
          <div className="col-span-2 flex justify-end">{data.maintenance.on.time}</div>
          <div className="col-span-1 flex justify-end">{data.repair.on.time}</div>
          <div className="col-span-1 flex justify-end">{data.service.on.time}</div>
        </div>
        {open ? 
          <div className="space-y-2 h-20">
            <>
              <TimelineChart events={data.events!} personId={Number(data.person?.id)} from={data.dateShift.start_time} to={data.dateShift.end_time} shift={shift} height={16} width="100%"/>
              <HourHeatMap events={data.events!} personId={Number(data.person?.id)} from={data.dateShift.start_time} to={data.dateShift.end_time} shift={shift} height={40} width="100%"/>
            </>
          </div> : <></>
        }
      </div>
    </div>
  )
}
